import { createSharedComposable, useCookie } from '#imports'

const _useSessionExpiry = () => useCookie('session_expiry', { readonly: true })

/**
 * Shared on the client so all call sites reuse one cookie ref — every
 * `useCookie` ref opens a BroadcastChannel and posts a message on
 * instantiation (Nuxt >= 3.18), which is O(N²) in refs on tile-heavy pages.
 * Kept per-call on the server, where a shared instance would leak state
 * between requests.
 */
export const useSessionExpiry = import.meta.client ? createSharedComposable(_useSessionExpiry) : _useSessionExpiry
